import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import Button from '@/core/components/elements/button';

import {
    ANIMATION_DELAY,
    ANIMATION_SPEED,
    optionsCardVariants,
} from '@/features/rapidstor/animations';

import buttonsClasses from '../CardButtons.module.scss';
import baseClasses from '../styles.module.scss';

interface Props {
    location: Location;
    desktop: boolean;
    loading: boolean;
}

export default function ContactCard({ location, desktop, loading }: Props) {
    const { t } = useTranslation();

    return (
        <motion.div
            layout
            variants={optionsCardVariants}
            initial="start"
            animate="show"
            transition={{
                duration: ANIMATION_SPEED,
                delay: ANIMATION_DELAY * 2,
            }}
        >
            <div
                className={`${baseClasses.card} ${baseClasses.upsell} ${
                    baseClasses.biggerUnit
                } ${!desktop ? baseClasses.mobile : baseClasses.desktop}`}
            >
                <span>{t('cta:bigger_unit')}</span>
                <div className={`${buttonsClasses.buttons}`}>
                    <Button
                        disabled={loading}
                        onclick={() => {
                            window.open(
                                `mailto:${
                                    location.corpCode === 'CRUK'
                                        ? t('contact_card:emailOverride')
                                        : location.contactEmail
                                }`,
                            );
                        }}
                        type="outlineOnBackground"
                        size="medium"
                    >
                        {t('cta:email_us')}
                    </Button>
                    <Button
                        disabled={loading}
                        onclick={() => {
                            window.open(`tel:${location.contactPhone}`);
                        }}
                        type="primary"
                        size="medium"
                    >
                        {t('cta:call_us')}
                    </Button>
                </div>
            </div>
        </motion.div>
    );
}
